<!-- Header -->
<medsurf-slide-edit-header [icon]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.GROUP"
  [label]="groupForm.value.name || ''"
[type]="'global.group'"></medsurf-slide-edit-header>

<!-- Content -->
<div #edit_overlay_template_scroll_panel
  class="flex flex-1 overflow-auto justify-content-center">
  <!-- Accordion -->
  <p-accordion [activeIndex]="[0, 1]"
    [multiple]="true"
    styleClass="no_border"
    class="w-full h-full ml-3 mr-3">
    <p-accordionTab [header]="'global.general' | translate"
      headerStyleClass="uppercase">
      <!-- Group Form -->
      @if (groupForm) {
        <medsurf-design-form-control-form
          [formGroup]="groupForm"
          [class]="'w-full'"
          (onSubmit)="onSubmit()">
          <div class="flex flex-column row-gap-2 align-items-center">
            <!-- Name -->
            <medsurf-design-form-control-input-text [control]="groupForm.controls.name"
              [label]="'global.title'"
              [class]="'w-full align-self-start'"
              [placeholder]="'global.title'"
            (valueChange)="onSubmit()"></medsurf-design-form-control-input-text>
            <!-- Color -->
            <medsurf-design-form-control-input-color-picker [control]="groupForm.controls.color"
              [label]="'global.color'"
              [class]="'w-full align-self-start'"
            (valueChange)="onSubmit()"></medsurf-design-form-control-input-color-picker>
          </div>
        </medsurf-design-form-control-form>
      }
    </p-accordionTab>
    <p-accordionTab [header]="'global.relation' | translate"
      headerStyleClass="uppercase">
      <!-- Annotations -->
      <medsurf-slide-edit-group-annotation-form [class]="'w-full'"></medsurf-slide-edit-group-annotation-form>
    </p-accordionTab>
  </p-accordion>
</div>
